import Layout from '@layout/Index'

export const taskNotice = [
  {
    path: '/task-notice',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "task-notice-table" */ './pages/TaskNoticeTable.vue'),
        meta: {
          title: '任务提示列表',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "task-notice-form" */ './pages/TaskNoticeForm.vue'),
        meta: {
          title: '添加任务提示',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "task-notice-form" */ './pages/TaskNoticeForm.vue'),
        meta: {
          title: '修改任务提示',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "task-notice-detail" */ './pages/TaskNoticeDetail.vue'),
        meta: {
          title: '任务提示详情',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/task-notice/task-notice.route.js